import { createGlobalStyle } from 'styled-components'
import  { globalStyles } from 'twin.macro'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GlobalStyles = createGlobalStyle(globalStyles, `
  html, body {
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    height: auto;
  }

  @media (max-width: 640px) {
    body {
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-y: auto;
      overscroll-behavior-x: none;
    }
  }

  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;
  }

  .slider-container .slick-track {
    display: flex !important;
    justify-content: flex-start !important;
  }

  .slick-prev:before, .slick-next:before {
    color: black;
  }
`);

export default GlobalStyles;